import {getMaxValuesOnPageProperty, getMaxValuesOnPageWithoutImageProperty, getNeededImageDimensions} from '../ChartPDFDefinitionPartsConstructors'
import BaseCreateDefinitionObjectStrategy from './BaseCreateDefinitionObjectStrategy'
import {ChartType} from '../../../constants'

export default class PieChartStrategy extends BaseCreateDefinitionObjectStrategy {
    constructor() {
        super(ChartType.PIE_CHART)
    }

    /**
     * for pie chart data are provided in one page, however we need to fit data to some pages (only if it needs)
     * this function split one page data depends on max number of values on one page
     * @param pagesData
     * @param pdfPrintParameters parameters for display pdf
     * @returns {Array}
     * @private
     */
    adjustDataParameters(pagesData, pdfPrintParameters) {

        const {paperOrientation, paperSize, fitDataToOnePage} = pdfPrintParameters
        // if data need to fit to one page return original data
        if (fitDataToOnePage) {
            return pagesData
        }
        const newPages = []
        let currentPage = {
            image: pagesData[0].image,
            data: []
        }

        // if no need data list - return page only with image
        if (!this._needToShowTable(pdfPrintParameters)) {
            newPages.push(currentPage)
            return newPages
        }

        const nValuesOnPageWithImage = getMaxValuesOnPageProperty({
            paperOrientation,
            paperSize,
            chartType: this.chartType,
        })
        const nValuesOnPageWithoutImage = getMaxValuesOnPageWithoutImageProperty({
            paperOrientation,
            paperSize,
            chartType: this.chartType,
            withHeader: pdfPrintParameters.showHeaderOnEachPage,
        })

        var currentPageCount = 0
        var enoughValuesToPage = false
        for (var i = 0; i < pagesData[0].data.length; i++) {
            currentPage.data.push(pagesData[0].data[i])
            currentPageCount++

            if (newPages.length === 0) {
                if (currentPageCount === nValuesOnPageWithImage) {
                    enoughValuesToPage = true
                }
            } else {
                if (currentPageCount === nValuesOnPageWithoutImage) {
                    enoughValuesToPage = true
                }
            }

            if (enoughValuesToPage) {
                enoughValuesToPage = false
                newPages.push(currentPage)
                currentPage = {data: []}
                currentPageCount = 0
            }
        }
        if (currentPage.data.length !== 0) {
            newPages.push(currentPage) // add last page if there are no added values
        }
        return newPages
    };

    addPageDataWithDataList(ddBuilder, docDefinition, pageData, pdfPrintParameters, pageIndex) {
        if (pageIndex === 0) { // first page
            ddBuilder.addImageAndData(docDefinition, pageData.image, pageData.data, pdfPrintParameters.showListOfDataValues,
                pdfPrintParameters.showListOfPercentValues, pdfPrintParameters.fitDataToOnePage)
        } else {
            ddBuilder.addOnlyTableToPage(docDefinition, pageData.data, pdfPrintParameters.showListOfDataValues, pdfPrintParameters.showListOfPercentValues)
        }
    };

    addPageDataWithoutDataList(ddBuilder, docDefinition, pageData, pdfPrintParameters, nPages) {
        ddBuilder.addOnlyImageToPage(docDefinition, pageData.image)
    };

    getMaxValuesOnPageWithoutTable({}) {
        return -1
    }

    getTotalNumberOfPages(lengthOfDataList, pdfPrintParameters) {
        const {paperSize, paperOrientation, showHeaderOnEachPage, fitDataToOnePage} = pdfPrintParameters
        if (fitDataToOnePage || !this._needToShowTable(pdfPrintParameters)) {
            return 1
        } else {
            const maxValuesOnPage = getMaxValuesOnPageProperty({
                paperOrientation,
                paperSize,
                chartType: ChartType.PIE_CHART,
            })
            const maxValuesOnPageWithoutImage = getMaxValuesOnPageWithoutImageProperty({
                paperOrientation,
                paperSize,
                chartType: ChartType.PIE_CHART,
                withHeader: showHeaderOnEachPage,
            })

            let nValues = lengthOfDataList
            let nPages = 0
            if (nValues >= maxValuesOnPage) {
                nPages++
                nValues -= maxValuesOnPage
            }
            if (nValues > 0) {
                nPages += Math.ceil(nValues / maxValuesOnPageWithoutImage)
            }
            return nPages
        }
    }

    getChartImageDimensions(lengthOfDataList, pdfPrintParameters) {
        return getNeededImageDimensions(pdfPrintParameters.paperOrientation, pdfPrintParameters.paperSize, this.chartType, false)
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfgenerator/doStrategy/PieChartStrategy.js